import AddToCartSection2 from "../addtocart";
import { useProducts } from "../../../../hooks/apis/menu";
import useChanegeCart from "../../../../hooks/helper/useChangeCart";
import { numberWithCommas } from "../../../../utils/numberWithCommas";

function Section2_product(props) {
  const { data, isLoading, error } = useProducts(props.id);
  const { addToCart, removeFromCart } = useChanegeCart();

  return (
    <div className="food-products">
      <div className={isLoading ? "active loading" : "loading"}>
        <img src="/images/loading.svg" className="img-fluid" alt="loading" />
      </div>
      {data &&
        data.products?.map((product, index) => {
          let rate = +product.rate;
          let rate_width = (rate * 100) / 5;
          let rate_hide = 100 - rate_width;
          return (
            <div className="product" key={index}>
              <a href="#!">
                <img
                  src={product.photo}
                  className="img-fluid"
                  alt={product.title}
                  title={product.title}
                />
              </a>
              <div className="info-product">
                <h4>{product.title}</h4>
                <p className="desc">{product.description}</p>
                <p className="price-rate">
                  <span className="rate" title={product.description}>
                    {[...Array(5)].map((star, index) => {
                      return <i className="fas fa-star" key={index}></i>;
                    })}
                    <span
                      className="show-rate-percent"
                      style={{ width: rate_hide + "%" }}
                    ></span>
                  </span>
                  <span className="price">
                    {numberWithCommas(product.price)}
                    <span className="currency">تومان</span>
                  </span>
                </p>
                <AddToCartSection2
                  product={product}
                  addToCart={addToCart}
                  removeFromCart={removeFromCart}
                />
              </div>
            </div>
          );
        })}
    </div>
  );
}

export default Section2_product;
